function generateRandomStockItems(count) {
  const categories = [
    "Mini Cooper",
    "BMW",
    "Mercedes",
    "Audi",
    "Toyota",
    "Honda",
  ];
  const parts = [
    "Engine Oil",
    "Brake Pads",
    "Air Filter",
    "Spark Plug",
    "Radiator",
    "Alternator",
    "Battery",
    "Headlight",
    "Taillight",
    "Windscreen",
    "Side Mirror",
    "Tire",
    "Wheel Rim",
    "Muffler",
    "Catalytic Converter",
    "Fuel Pump",
    "Ignition Coil",
    "Timing Belt",
    "Water Pump",
    "Shock Absorber",
  ];
  const zones = ["Zone A", "Zone B", "Zone C"];
  const aisles = ["Aisle 1", "Aisle 2", "Aisle 3", "Aisle 4", "Aisle 5"];
  const bays = [
    "BAY A1",
    "BAY A2",
    "BAY B1",
    "BAY B2",
    "BAY C1",
    "BAY C2",
    "BAY C3",
    "BAY C4",
  ];

  const items = [];

  for (let i = 0; i < count; i++) {
    const category = categories[Math.floor(Math.random() * categories.length)];
    const part = parts[Math.floor(Math.random() * parts.length)];
    const randomCode = `MC${Math.floor(
      Math.random() * 9000 + 1000
    )}${String.fromCharCode(
      65 + Math.floor(Math.random() * 26)
    )}${String.fromCharCode(65 + Math.floor(Math.random() * 26))}`;

    const item = {
      id: `${String.fromCharCode(
        65 + Math.floor(Math.random() * 26)
      )}${Math.floor(Math.random() * 10)}${String.fromCharCode(
        65 + Math.floor(Math.random() * 26)
      )}${Math.floor(Math.random() * 10)}${String.fromCharCode(
        65 + Math.floor(Math.random() * 26)
      )}`,
      code: randomCode,
      description: `${part} for ${category}`,
      active: ["Active", "Inactive", "Under Threshold"][i % 3],
      inventory: Math.floor(Math.random() * 10),
      thresholdValue: Math.floor(Math.random() * 5) + 3,
      bayLocation: `${zones[Math.floor(Math.random() * zones.length)]} >${
        aisles[Math.floor(Math.random() * aisles.length)]
      } - ${bays[Math.floor(Math.random() * bays.length)]}`,
      lastSynced: new Date(
        Date.now() - Math.floor(Math.random() * 30) * 24 * 60 * 60 * 1000
      ).toLocaleString("en-US", {
        weekday: "short",
        month: "short",
        day: "numeric",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      }),
    };

    items.push(item);
  }

  return items;
}

export const rows = generateRandomStockItems(25);
